export default "__VITE_ASSET__f80f6fba__"